import styled, { css } from 'styled-components';
import { OPEN_IN_APP_HEIGHT } from '../../../../../../profile/body-section/body-sub-sections/OpenInAppBanner/OpenInAppBanner';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import { MOBILE_HEADER_HEIGHT, Breakpoint, ZIndex } from '../../../../../styles/constants';
import { TOP_NAVIGATION_BAR_HEIGHT } from '../../../../TopNavigationBar/TopNavigationBar.styles';

const getFilterOffset = () => (props: { enabledFilterOffset?: boolean }) => css`
  top: ${props.enabledFilterOffset
    ? `calc(${MOBILE_HEADER_HEIGHT} + ${OPEN_IN_APP_HEIGHT}px);`
    : MOBILE_HEADER_HEIGHT};
`;

export const ShadowBackground = styled.div<{ enabledFilterOffset?: boolean }>`
  ${getFilterOffset()}
  background-color: ${ThemeColours.mono800};
  height: 100%;
  opacity: 0.4;
  overflow: visible;
  position: absolute;
  width: 100%;
  ${Breakpoint.LARGE} {
    top: 104px;
  }
  z-index: ${ZIndex.NORMAL};
`;

export const RelativeOffset = styled.div<{
  enabledFilterOffset?: boolean;
  topNavExperiment?: boolean;
  inline?: boolean;
}>`
  ${getFilterOffset()}
  overflow: visible;
  width: 100%;

  ${Breakpoint.SMALL} {
    position: absolute;
    margin-top: 0;
    top: 44px;
  }

  ${Breakpoint.MEDIUM} {
    margin-top: ${props =>
      props.topNavExperiment && !props.inline ? TOP_NAVIGATION_BAR_HEIGHT : '0'};
    top: 44px;
  }
`;

export const FloatingContainer = styled.div<{ inline?: boolean }>`
  align-items: flex-start;
  background-color: ${ThemeColours.white};
  border-radius: 16px;
  bottom: 0;
  box-shadow: 0px 1px 10px rgba(7, 35, 38, 0.1);
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100vh;
  left: 0;
  max-height: 100vh;
  padding: 70px 0px 0px 16px;
  position: absolute;
  right: 0;
  top: 0;
  transition: all 0.75s ease;
  width: inherit;
  z-index: ${ZIndex.BEHIND};

  &:focus {
    outline: none;
  }

  ${Breakpoint.SMALL} {
    bottom: unset;
    height: unset;
    left: unset;
    max-height: 95vh;
    padding: 24px 24px 32px;
    right: unset;
    top: 54px;
    width: 700px;
    z-index: ${ZIndex.POPUP};
  }
`;
